import(/* webpackMode: "eager" */ "/vercel/path0/apps/public/app/error.tsx");
